$(document).ready(function () {
    // --- Globals ---//
    // Search will hide/show relevant submissions
    $('input#searchterm').keyup(function () {
        var value = $(this).val();
        $('table tr').not('table tr:first-child').each(function () {
            if ($(this).children('td').text().search(new RegExp(value, 'i')) < 0) {
                $(this).hide();
            } else {
                $(this).show();
            }
        });
    });
});
